import { roleBindingResourceCompile } from '../../../authz/authz.functions';
import { useQueryRoleBindings } from '../../../authz/authz.hooks';
import { useInfiniteQueryFetchAllPages } from '../../../services/hooks';

export const useQueryAllRoleBindings = (workspaceName: string) => {
  const workspaceRoleBindingsQuery = useQueryRoleBindings(
    { filter: `resource='${roleBindingResourceCompile(workspaceName)}'` },
    {
      select: (data) => {
        const roleBindingsFromAllPages = data.pages.flatMap((page) => page.roleBindings || []);
        return { pages: roleBindingsFromAllPages, pageParams: data.pageParams };
      },
    }
  );
  useInfiniteQueryFetchAllPages(workspaceRoleBindingsQuery);
  return workspaceRoleBindingsQuery.data?.pages;
};
